import { render, staticRenderFns } from "./futer_cases.vue?vue&type=template&id=393297b6&scoped=true"
import script from "./futer_cases.vue?vue&type=script&lang=js"
export * from "./futer_cases.vue?vue&type=script&lang=js"
import style0 from "./futer_cases.vue?vue&type=style&index=0&id=393297b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393297b6",
  null
  
)

export default component.exports